// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownButton__mrg5Q_ZmcT{border-top-left-radius:0;border-bottom-left-radius:0}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/contacts/components/details/components/userDetails/components/userInfo/components/emailAction/contactEmail.module.scss"],"names":[],"mappings":"AAAA,4BACE,wBAAA,CACA,2BAAA","sourcesContent":[".dropdownButton {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownButton": `dropdownButton__mrg5Q_ZmcT`
};
export default ___CSS_LOADER_EXPORT___;
